
<div class="mt-5">
  <split-text 
      theme="secondery" 
      title="Total">
  </split-text>
  <table class="w-full">
    <tbody>
        <tr>
            <td *ngFor="let column of columns; let i = index" [style.width.%]="this.widthColumns[i]">
              <ng-container
                  *ngTemplateOutlet="column;">
                </ng-container>
            </td>
          </tr >
    </tbody>
  </table>
</div>
